// import gobalConfig from "@/config/index.config.js";
import dictFormat from "@/common/filters/dictFormat.js"
import moment from 'moment';

export default function(value, entity,noUnit=false) {
	if (value !== undefined && (value === value) && value !== null) {

		if (entity.valueType == 2 || entity.valueType == 3) {
			if (entity.retain1 !== undefined && entity.retain1 !== null && entity.retain1 !== '') {
				if (value < Number(entity.retain1)) {
					value = Number(entity.retain1);
				}
			}
			if (entity.retain2 !== undefined && entity.retain2 !== null && entity.retain2 !== '') {
				if (value > Number(entity.retain2)) {
					value = Number(entity.retain2);
				}
			}
			if (entity.retain3 !== undefined && entity.retain3 !== null && entity.retain3 !== '') {
				value = value / Number(entity.retain3);
			}
		}
		if (entity.valueType == 3 && entity.formatType != 5) {
			value = numberformat(value, 2, 2);
		}
		if (entity.valueType == 2) {
			value = numberformat(value, 2, 0);
		}
		if (entity.formatType == 1) {
			// 直接返回
			return value;
		} else if (entity.formatType == 2) {
			//拼接返回
			return value + (noUnit ? '' : (' ' + entity.formatString));
		} else if (entity.formatType == 3) {
			//替换固定字符串返回
			return entity.formatString.replace('$0', value);
		} else if (entity.formatType == 4) {

			return dictFormat(value, entity.dictTypeCode);
		} else if (entity.formatType == 5) {
			//百分比返回
			return numberformat(value, 1, null);
		} else if (entity.formatType == 6) {
			//时间格式返回
			return moment(value).format(entity.formatString);
		} else {
			// if (gobalConfig.envTxt) {
				if (process.env == "development") {
				return 'no-pformat';
			} else {
				return;
			}
		}
	} else {
		return '-';
	}


}

function numberformat(arg, type, extra) {
	if (isNaN(Number(arg)) || arg === null) {
		return '';
	}
	//1转换成百分比表示
	if (type == 1) {
		if (arg % 1 === 0) {
			// 小数点后面全是0的话则不显示小数点
			return (Number(arg) * 100).toFixed(0) + '%';
		}
		return (Number(arg) * 100).toFixed(2) + '%';
	} else if (type == 2) {
		//2保留小数extra位
		return Number(arg).toFixed(extra);
	}
}
